import React, { FC } from "react";
import arrowIcon from "../assets/images/link-arrow.svg";
import useTranslations from "../hooks/useTranslations";
import { PersonContact } from "../models/person/Person";
import { formatPhoneNumberLink } from "../utilities/links";
import SanityImage from "./SanityImage";

interface Props extends PersonContact {
  textColor: "light" | "dark";
  compact?: boolean;
}

export const ContactPerson: FC<Props> = ({
  name,
  email,
  phoneNumber,
  profileImage,
  textColor,
  compact
}) => {
  let textColorClass: string;
  const translations = useTranslations();

  const imageSize = compact ? 90 : 120;

  const imageMargin = compact ? "mr-6" : "mr-10";

  switch (textColor) {
    case "dark": {
      textColorClass = "text-brand-primary-20";
      break;
    }
    default:
      textColorClass = "text-neutral-100";
      break;
  }

  return (
    <li className={`flex flex-none justify-start mb-8 ${textColorClass}`}>
      <div className={`flex-none ${imageMargin}`}>
        <SanityImage
          className="rounded-full"
          image={profileImage}
          loading="lazy"
          width={imageSize}
          height={imageSize}
        />
      </div>
      <div className="flex flex-col justify-start items-start w-4/5 pt-1 text-xl text-neutral-100">
        <strong className="text-current">{name}</strong>
        {!!phoneNumber && (
          <a
            href={formatPhoneNumberLink(phoneNumber)}
            className="no-underline text-current hover:underline focus:underline"
          >
            {phoneNumber}
          </a>
        )}
        {!!email && (
          <a
            href={`mailto:${email}`}
            className="group inline-flex justify-start items-center font-bold text-link"
          >
            {translations.sendEmail}{" "}
            <svg
              width={16}
              height={16}
              className="ml-2 fill-current card-arrow group-hover:translate-x-1"
            >
              <use xlinkHref={arrowIcon.url} />
            </svg>
          </a>
        )}
      </div>
    </li>
  );
};
